import { LogLevel } from '@azure/msal-common';
import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  production: false,
  logLevel: LogLevel.Warning,
  signUpSignInPolicyName: `b2c_1a_signup_signin_staging`,
  authorityDomain: 'testulplatform.b2clogin.com',
  authorityBase: 'https://testulplatform.b2clogin.com/testulplatform.onmicrosoft.com',
  defaultClientId: 'b1b9e090-de04-4506-a61e-9de499a21423',
  scope: 'openid profile https://testulplatform.onmicrosoft.com/platform-systemtests-api-staging/read offline_access',
  loginRedirectUri: '/auth',
  logoutRedirectUri: '/',
  tenantId: '4eec6d53-627b-4ec6-9db5-74e6ef0ab27d'
};